import axios from 'axios';
import router from '../router';
import store from '../store/index.js';
import KeyWords from "@/common/Languages/keyWords";
import ErrorMsgs from "@/common/Languages/errorHandling.js";
import Encryption from "@/common/encryption";
const instance = axios.create({
  baseURL: '',
});
const allowedUrls = [];
let redirectFlag = true;
const logoutFunc = function() {
  const logout_redirect_url =
  store.getters.getConfig.oauth_authorization_url +
  "?response_type=code&client_id=" +
  store.getters.getConfig.client_id +
  "&scope=profile&redirect_uri=" +
  store.getters.getConfig.redirect_uri;
  const logOutUri =  store.getters.getConfig.auth_logout_url +
  "?goto=" +
  encodeURIComponent(logout_redirect_url);
  store.dispatch("logout").then(() => {
    sessionStorage.clear();
    window.location = `${logOutUri}`;
  });
}
const showSessionExpiredFunc = function () {
  const snackbarObj = {
    title: "Session Expired",
    subtitle: "Your login session has expired",
    text: "Please relogin to REP.",
    btnTitle: "Relogin",
    btnClick: logoutFunc
  };
  store.dispatch("setErrorMessage", snackbarObj);
  router.push("/error");
};
instance.interceptors.request.use(request => {
  request.headers["tokenId"] = store.getters.getAuthToken;
  request.headers["refresh_token"] = store.getters.getRefreshToken;
  request.headers["client_id"] = store.getters.getConfig.client_id;
  request.headers["redirect_uri"] = store.getters.getConfig.redirect_uri;
  return request;
});

instance.interceptors.response.use(
  response => {
    store.dispatch("setProcessingOverlay", false);
    if (response.headers && response.headers.tokenid) {
      store.dispatch("setAuthTokenFromAPI", {
        access_token: response.headers.tokenid,
      }).then(() => {
        const encryption = new Encryption(
          store.getters.getConfig["rsi_services"]
        );
        // encrypt token
        encryption.storeDataWithEncrypt(
          store.getters.getConfig["rsi_user"],
          response.headers.tokenid
        );
      });
    }
    if (response.data == 'invalid token') {
      showSessionExpiredFunc();
    }
    return response;
  },
  error => {
    store.dispatch("setProcessingOverlay", false);
    if (error.message === 'Network Error') {
      const snackbarObj = {
        show: true,
        timeout: 0,
        msg: `Network Error`,
        close: () => {
          console.log("close function called!!!!");
        }
      };
      store.dispatch("setSnackbarDetails", snackbarObj);
    }
    if (
      error.response &&
      (error.response.status === 403 || error.response.status === 401 || error.response.status === 400)
    ) {
      if (error.response.data == "invalid refresh token") {
        showSessionExpiredFunc();
        return error;
      } else {
        const snackbarObj = {
          title: "Access Denied",
          subtitle: "You don't have permission to access this application",
          text:"Please contact your RSI account team",
          btnTitle: "Exit",
          btnClick: logoutFunc
        };
        store.dispatch("setProgressBar", false);
        store.dispatch("setErrorMessage", snackbarObj);
        router.push("/error");
        return error;
      }
    }

    if (error.response && (error.response.status === 500 || error.response.status === 504 || error.response.status === 503)) {
      const resConfig = error.response.config;
      let apiString = "";
      let lastIndex = "";
      let subStr = "";
      if (resConfig) {
        apiString = resConfig.url;
        lastIndex = apiString.lastIndexOf("/");
        subStr = apiString.substring(lastIndex, apiString.length);
        redirectFlag = allowedUrls.indexOf(subStr) > -1 ? false : true;
      }

      store.dispatch("setProgressBar", false);
      store.dispatch("setProcessingOverlay", false);
      if (router && router.history && router.history.current.name === "Dashboard" && redirectFlag) {
        const snackbarObj = {
          title: "Access Denied",
          subtitle: "It appears that REP is not available at this time",
          text: "If you continue to experience this error please reach out to your REP administrator or contact support",
          btnTitle: "Exit",
          extraBtn: {
            btnClick: () => {
              window.location = KeyWords.customerSuccessURL;
            },
            btnTitle: "Contact"
          },
          btnClick: logoutFunc
        };
        store.dispatch("setErrorMessage", snackbarObj);
        router.push("/error");
      } else {
        const msgkey = subStr.replace("/", "");
        const msg = ErrorMsgs[msgkey] ? ErrorMsgs[msgkey] : ErrorMsgs.all;
        /*const snackbarObj = {
          msg,
          timeout: 0,
          show: true,
        };
        store.dispatch("setSnackbarDetails", snackbarObj);
        router.push("/");
        */
        //change error message from snackbar to popup dialog
        const errorObj = {
          showDlg:true,
          buttons:{
            CloseButton:{
                Caption:"Close"
            }
          },
          title:"Error",
          type:"Error",
          message:msg
        };
        store.dispatch("setConfirmDialogDetails", errorObj);
      }

      return error;
    }
    return Promise.reject(error);
  },
);

export default instance;
